module.exports = __webpack_public_path__ + "img/glasstype-lenses.27ffeb55.svg";